import { useTheme } from "@mui/material"
import SvgIcon from "@mui/material/SvgIcon"
import { ReactElement } from "react"

import { ReactComponent as EnaLogoDark } from "../../assets/connet-direct-dark-mode-logo-01.svg"
import { ReactComponent as EnaLogoLight } from "../../assets/connet-direct-primary-logo-01.svg"

interface ISvgProps {
    fontSize?: string
    viewBox?: string
    modeOverride?: "light" | "dark" | undefined
}

/**
 * Connect direct logo. Picks logo type by inspecting theme. Allows manual
 * theme override.
 */
const ConnectDirectLogo = ({
    fontSize,
    viewBox,
    modeOverride,
}: ISvgProps): ReactElement => {
    const theme = useTheme()
    const mode = modeOverride || theme.palette.mode
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <SvgIcon sx={{ fontSize }}>
            {mode === "light" ? (
                <EnaLogoLight viewBox={viewBox} aria-label="Ena light logo" />
            ) : (
                <EnaLogoDark viewBox={viewBox} aria-label="Ena dark logo" />
            )}
        </SvgIcon>
    )
}

ConnectDirectLogo.defaultProps = {
    fontSize: "200px",
    viewBox: "440 350 1070 400",
    modeOverride: undefined,
}

export default ConnectDirectLogo
